<template>
  <div id="pictureVocabulary" class="container font-size-control pt-3 pb-3">
    <div class="row d-flex align-items-center">
      <div class="col-1 clickable" @click="pageLeft()">
        <font-awesome-icon class="back-icon pointer" size="3x" :icon="['fa', 'angle-left']" /></div>
      <div class="col-10" v-if="page > -1">
        <div class="text-center p-3">
            <div><p style="font-size:2rem">{{page}}/{{data.length}}</p></div>
          <img :src="currentPage.image" width="90%" />
        </div>

        <h4 @click="playAudioFile(currentPage.audio)" v-bind:class="{ 'h4': true, 'clickable': currentPage.audio }">
          <span v-if="currentPage.audio"><i class="fa fa-volume-up"></i></span> {{ currentPage.name }}
        </h4>

        <span class="pron">{{ currentPage.pronouncing }}</span><br />
        {{ currentPage.partOfSpeech }} {{ currentPage.name_i18N[0].value }}<br /><br />

        <p v-for="(example, exampleIndex) in currentPage.examples" :key="exampleIndex"
          v-bind:class="{ 'clickable': example.audio }"
          @click="playAudioFile(example.audio)">
          <span v-if="example.audio"><i class="fa fa-volume-up"></i></span> {{ example.text }}<br />
          <span v-for="(lang, langIndex) in example.text_i18N" :key="langIndex">{{ lang.value }}</span>
        </p>
      </div>
      <div class="col-1 clickable" @click="pageRight()"><font-awesome-icon class="back-icon pointer" size="3x" :icon="['fa', 'angle-right']" /></div>
    </div>
  </div>
</template>

<script>
  import audioPlayerMixin from './mixins/audioPlayerMixin.js'

  export default {

    name: 'PictureVocabulary',

    mixins: [audioPlayerMixin],

    props: {
      data: {
        type: Array,
        required: true,
        default: () => {
          return []
        }
      }
    },

    data () {
      return {
        pages: [],
        page: 1
      }
    },

    computed: {
      currentPage () {
        return this.pages[this.page - 1]
      }
    },

    created () {
      this.pages = this.data

      this.$watch('page', (val, oldVal) => {
        this.audio && this.audio.pause()
      })
    },

    beforeMount () {
      window.addEventListener('keyup', this.handleKeyup)
    },

    beforeDestroy () {
      window.removeEventListener('keyup', this.handleKeyup)
    },

    methods: {
      pageLeft () {
        let page = this.page - 1 > 0 ? this.page - 1 : this.page

        this.page = -1

        this.$nextTick(() => {
          this.page = page
        })
      },

      pageRight () {
        let page = this.page + 1 <= this.pages.length ? this.page + 1 : this.page

        this.page = -1

        this.$nextTick(() => {
          this.page = page
        })
      }
    }
  }
</script>

<style lang="scss" scoped>
  @import '../assets/style/app.scss';

  #pictureVocabulary {
    text-align: left;
  }

  .clickable {
    cursor: pointer;
  }
</style>



// WEBPACK FOOTER //
// PictureVocabulary.vue?612d399a